import React from 'react';

const iconProps = {
	width: 18,
	height: 18,
	viewBox: '0 0 18 18',
	fill: 'none',
	xmlns: 'http://www.w3.org/2000/svg',
	'aria-hidden': true
};

const RejectedIcon = () => (
	<svg {...iconProps}>
		<rect x="0.5" y="0.5" width="17" height="17" rx="8.5" fill="white" />
		<rect x="0.5" y="0.5" width="17" height="17" rx="8.5" stroke="#FF0000" />
		<path
			d="M12.7123 5.76539C12.888 5.58966 12.888 5.30473 12.7123 5.129C12.5366 4.95326 12.2517 4.95326 12.0759 5.129L9 8.20491L5.92409 5.129C5.74835 4.95326 5.46343 4.95326 5.28769 5.129C5.11195 5.30473 5.11195 5.58966 5.28769 5.76539L8.3636 8.84131L5.28769 11.9172C5.11195 12.093 5.11195 12.3779 5.28769 12.5536C5.46343 12.7294 5.74835 12.7294 5.92409 12.5536L9 9.4777L12.0759 12.5536C12.2517 12.7294 12.5366 12.7294 12.7123 12.5536C12.888 12.3779 12.888 12.093 12.7123 11.9172L9.6364 8.84131L12.7123 5.76539Z"
			fill="#F63D68"
		/>
	</svg>
);

const OnHoldIcon = () => (
	<svg {...iconProps}>
		<rect
			x="0.5"
			y="0.5"
			width="17"
			height="17"
			rx="8.5"
			fill="none"
			stroke="#FDB022"
		/>
		<path
			d="M7 5C7.55228 5 8 5.44772 8 6V12C8 12.5523 7.55228 13 7 13C6.44772 13 6 12.5523 6 12V6C6 5.44772 6.44772 5 7 5Z"
			fill="#FDB022"
		/>
		<path
			d="M11 5C11.5523 5 12 5.44772 12 6V12C12 12.5523 11.5523 13 11 13C10.4477 13 10 12.5523 10 12V6C10 5.44772 10.4477 5 11 5Z"
			fill="#FDB022"
		/>
	</svg>
);

const WithdrawnIcon = () => (
	<svg {...iconProps}>
		<rect x="0.5" y="0.5" width="17" height="17" rx="8.5" fill="white" />
		<rect x="0.5" y="0.5" width="17" height="17" rx="8.5" stroke="#D5D7DA" />
		<path
			d="M12.7123 5.76539C12.888 5.58966 12.888 5.30473 12.7123 5.129C12.5366 4.95326 12.2517 4.95326 12.0759 5.129L9 8.20491L5.92409 5.129C5.74835 4.95326 5.46343 4.95326 5.28769 5.129C5.11195 5.30473 5.11195 5.58966 5.28769 5.76539L8.3636 8.84131L5.28769 11.9172C5.11195 12.093 5.11195 12.3779 5.28769 12.5536C5.46343 12.7294 5.74835 12.7294 5.92409 12.5536L9 9.4777L12.0759 12.5536C12.2517 12.7294 12.5366 12.7294 12.7123 12.5536C12.888 12.3779 12.888 12.093 12.7123 11.9172L9.6364 8.84131L12.7123 5.76539Z"
			fill="#D5D7DA"
		/>
	</svg>
);

const InternalReviewIcon = () => (
	<svg {...iconProps}>
		<rect width="18" height="18" rx="9" fill="white" />
		<rect
			x="0.6"
			y="0.6"
			width="16.8"
			height="16.8"
			rx="3.4"
			stroke="#4E5BA6"
			strokeWidth="1.2"
		/>
		<path
			d="M9.00611 12.1464C9.50467 12.1468 9.9095 12.5104 9.90974 12.9583C9.90974 13.4065 9.50482 13.7699 9.00611 13.7703H8.99434C8.49549 13.77 8.09071 13.4066 8.09071 12.9583C8.09095 12.5103 8.49564 12.1467 8.99434 12.1464H9.00611Z"
			fill="#4E5BA6"
		/>
		<path
			d="M9.00022 4.68811C10.6077 4.68822 11.9041 5.85297 11.9041 7.29721C11.904 8.43605 11.0698 9.03607 10.5239 9.37137L10.5251 9.37243C10.29 9.51829 10.1383 9.63281 10.0403 9.7509C9.95909 9.84881 9.90385 9.96239 9.90385 10.1442V10.3715C9.90385 10.8198 9.49918 11.1833 9.00022 11.1834C8.50116 11.1834 8.09659 10.8199 8.09659 10.3715V10.1442C8.09659 8.97841 8.95065 8.37642 9.4991 8.03617L9.50263 8.03405C9.72573 7.89716 9.87136 7.78504 9.96504 7.67144C10.0434 7.57636 10.0968 7.46785 10.0968 7.29721C10.0968 6.7497 9.60947 6.31203 9.00022 6.31192C8.39088 6.31192 7.90363 6.74963 7.90363 7.29721C7.90355 7.74555 7.49901 8.10911 7 8.10911C6.50099 8.10911 6.09645 7.74555 6.09637 7.29721C6.09637 5.8529 7.39267 4.68811 9.00022 4.68811Z"
			fill="#4E5BA6"
		/>
	</svg>
);

const PresentedIcon = () => (
	<svg {...iconProps}>
		<rect width="18" height="18" rx="9" fill="white" />
		<rect
			x="0.6"
			y="0.6"
			width="16.8"
			height="16.8"
			rx="3.4"
			stroke="#6172F3"
			strokeWidth="1.2"
		/>
		<path
			d="M8.9266 11.7184C10.473 11.6976 11.9923 12.1318 13.2639 12.9653C14.536 13.7991 15.5002 14.994 16 16.3873L14.8006 16.8482C14.4053 15.7457 13.6322 14.7734 12.5789 14.083C11.5249 13.3922 10.2512 13.0241 8.94326 13.0417C7.6355 13.0594 6.37459 13.4608 5.34409 14.1788C4.31431 14.8965 3.57381 15.8885 3.21395 17L2 16.5801C2.45562 15.1726 3.38245 13.9502 4.62884 13.0816C5.87448 12.2136 7.38022 11.7392 8.9266 11.7184Z"
			fill="#6172F3"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M9.00364 4C10.9006 4.00001 12.4404 5.59249 12.4404 7.55446V7.55769C12.4299 9.47041 10.9754 11.0352 9.12754 11.1003L9.0151 11.0938C9.01297 11.0938 9.01012 11.0938 9.00677 11.0938C8.99641 11.0938 8.98679 11.0942 8.98074 11.0949C8.94729 11.0992 8.91344 11.1015 8.87975 11.1003C7.0351 11.0353 5.56691 9.47342 5.56689 7.55446C5.56689 5.5938 7.09684 4 9.00364 4ZM9.00364 5.32229C7.80593 5.32229 6.84539 6.32192 6.84539 7.55446C6.84541 8.75282 7.75754 9.72703 8.90786 9.77586C8.96898 9.77175 9.03239 9.77296 9.09526 9.77694C10.2431 9.73044 11.1534 8.75876 11.1619 7.55446L11.1504 7.32618C11.0397 6.20191 10.1196 5.3223 9.00364 5.32229Z"
			fill="#6172F3"
		/>
	</svg>
);

const ClientAssessmentIcon = () => (
	<svg {...iconProps}>
		<rect width="18" height="18" rx="9" fill="white" />
		<rect
			x="0.6"
			y="0.6"
			width="16.8"
			height="16.8"
			rx="3.4"
			stroke="#7A5AF8"
			strokeWidth="1.2"
		/>
		<path
			d="M6.52679 10.5444C6.75665 10.2995 7.12964 10.2995 7.35949 10.5444C7.58906 10.7895 7.58888 11.1863 7.35949 11.4315L5.59347 13.3162C5.36361 13.5613 4.99067 13.5612 4.76077 13.3162L4.17242 12.6877C3.94271 12.4424 3.94258 12.0446 4.17242 11.7995C4.40219 11.5552 4.77442 11.5551 5.00416 11.7995L5.17664 11.9835L6.52679 10.5444Z"
			fill="#7A5AF8"
		/>
		<path
			d="M13.4116 11.6165C13.7366 11.6167 13.9999 11.8975 14 12.2441C14 12.5908 13.7367 12.8715 13.4116 12.8716H9.29031C8.96516 12.8716 8.70196 12.5909 8.70196 12.2441C8.70211 11.8974 8.96526 11.6165 9.29031 11.6165H13.4116Z"
			fill="#7A5AF8"
		/>
		<path
			d="M6.52679 4.68386C6.7567 4.43873 7.1296 4.43869 7.35949 4.68386C7.58912 4.92901 7.58906 5.32583 7.35949 5.57102L5.59347 7.45571C5.36361 7.70077 4.99067 7.7007 4.76077 7.45571L4.17242 6.82714C3.94253 6.5819 3.94252 6.18418 4.17242 5.93896C4.40224 5.69437 4.77437 5.69433 5.00416 5.93896L5.17664 6.12293L6.52679 4.68386Z"
			fill="#7A5AF8"
		/>
		<path
			d="M13.4116 5.75601C13.7367 5.75613 14 6.03682 14 6.38356C14 6.73026 13.7367 7.01099 13.4116 7.01111H9.29031C8.96519 7.01111 8.70201 6.73033 8.70196 6.38356C8.70196 6.03675 8.96516 5.75601 9.29031 5.75601H13.4116Z"
			fill="#7A5AF8"
		/>
	</svg>
);

const ClientDefinitionIcon = () => (
	<svg {...iconProps}>
		<rect width="18" height="18" rx="9" fill="white" />
		<rect
			x="0.6"
			y="0.6"
			width="16.8"
			height="16.8"
			rx="3.4"
			stroke="#4A1FB8"
			strokeWidth="1.2"
		/>
		<path
			d="M12.4619 5.75504C12.7503 5.48143 13.2252 5.47512 13.5225 5.74065C13.8195 6.00631 13.8263 6.4438 13.5381 6.71762L7.72071 12.2448C7.57945 12.379 7.38456 12.4544 7.18165 12.4544C6.97892 12.4544 6.78476 12.3788 6.64356 12.2448L4.46192 10.1721C4.17368 9.8983 4.18053 9.46081 4.47755 9.19515C4.7748 8.92962 5.24971 8.93593 5.5381 9.20954L7.18165 10.7704L12.4619 5.75504Z"
			fill="#4A1FB8"
		/>
	</svg>
);

const PreHiringIcon = () => (
	<svg {...iconProps}>
		<rect width="18" height="18" rx="9" fill="white" />
		<rect x="0.6" y="0.6" width="16.8" height="16.8" rx="8.4" fill="#7A5AF8" />
		<rect
			x="0.6"
			y="0.6"
			width="16.8"
			height="16.8"
			rx="8.4"
			stroke="#7A5AF8"
			strokeWidth="1.2"
		/>
		<path
			d="M10.7764 5.5C12.0042 5.5002 13 6.48323 13 7.69824C13 10.4511 10.408 12.0755 9.24805 12.4648C9.11205 12.512 8.88795 12.512 8.75195 12.4648C7.59195 12.0755 5 10.4511 5 7.69824C5.00004 6.48323 5.99583 5.5002 7.22363 5.5C7.95162 5.5 8.596 5.84604 9 6.38086C9.404 5.84604 10.0524 5.5 10.7764 5.5Z"
			fill="white"
		/>
	</svg>
);

const OfferIcon = () => (
	<svg {...iconProps}>
		<rect width="18" height="18" rx="9" fill="white" />
		<rect x="0.6" y="0.6" width="16.8" height="16.8" rx="8.4" fill="#4E5BA6" />
		<rect
			x="0.6"
			y="0.6"
			width="16.8"
			height="16.8"
			rx="8.4"
			stroke="#4E5BA6"
			strokeWidth="1.2"
		/>
		<path
			d="M9.69105 5.57767L10.395 6.99715C10.491 7.19475 10.7469 7.38428 10.9629 7.42057L12.2388 7.6343C13.0547 7.77141 13.2467 8.36824 12.6587 8.957L11.6668 9.95709C11.4989 10.1265 11.4069 10.4531 11.4589 10.687L11.7428 11.925C11.9668 12.9049 11.4509 13.284 10.591 12.7718L9.39509 12.0581C9.17911 11.929 8.82315 11.929 8.60317 12.0581L7.40731 12.7718C6.5514 13.284 6.03146 12.9009 6.25543 11.925L6.5394 10.687C6.5914 10.4531 6.49941 10.1265 6.33143 9.95709L5.33954 8.957C4.7556 8.36824 4.94358 7.77141 5.75949 7.6343L7.03535 7.42057C7.24732 7.38428 7.5033 7.19475 7.59929 6.99715L8.30321 5.57767C8.68717 4.80744 9.3111 4.80744 9.69105 5.57767Z"
			fill="white"
		/>
	</svg>
);

const OnboardingIcon = () => (
	<svg {...iconProps}>
		<rect x="0.5" y="0.5" width="17" height="17" rx="8.5" fill="#293056" />
		<rect x="0.5" y="0.5" width="17" height="17" rx="8.5" stroke="#293056" />
		<path
			d="M9.2952 11.8429C9.14489 11.9932 9.14489 12.2369 9.2952 12.3872C9.44552 12.5376 9.68922 12.5376 9.83953 12.3872L12.9546 9.27214C13.0268 9.19996 13.0674 9.10206 13.0674 8.99998C13.0674 8.8979 13.0268 8.8 12.9546 8.72781L9.83953 5.61271C9.68922 5.4624 9.44552 5.4624 9.29521 5.61271C9.14489 5.76302 9.14489 6.00673 9.29521 6.15704L11.7532 8.61508L5.31793 8.61508C5.10536 8.61508 4.93303 8.7874 4.93303 8.99998C4.93303 9.21255 5.10536 9.38488 5.31793 9.38488L11.7532 9.38488L9.2952 11.8429Z"
			fill="white"
		/>
		<path
			d="M5.14662 8.99998C5.14662 9.07448 5.20844 9.13474 5.28364 9.13474L11.7789 9.13474C11.8809 9.13474 11.9734 9.19567 12.0125 9.28904C12.0516 9.38246 12.0295 9.49 11.9573 9.5615L9.47611 12.0195C9.423 12.0722 9.42296 12.1583 9.47611 12.2109C9.52927 12.2635 9.61616 12.2635 9.66932 12.2109L12.8139 9.09568C12.8394 9.07039 12.8534 9.03572 12.8534 8.99998C12.8534 8.96423 12.8394 8.92957 12.8139 8.90428L9.66932 5.78904C9.61616 5.73645 9.52927 5.73645 9.47611 5.78904C9.42296 5.8417 9.423 5.92776 9.47611 5.98045L11.9573 8.43846C12.0295 8.50995 12.0516 8.6175 12.0125 8.71092C11.9734 8.80428 11.8809 8.86521 11.7789 8.86521L5.28364 8.86521C5.20844 8.86521 5.14662 8.92548 5.14662 8.99998ZM4.64191 8.99998C4.64191 8.64933 4.92969 8.36521 5.28364 8.36521L11.1697 8.36521L9.11926 6.33396C8.86905 6.08601 8.86901 5.68345 9.11926 5.43553C9.36953 5.18767 9.77591 5.18767 10.0262 5.43553L13.1708 8.55076C13.2909 8.66982 13.3581 8.83162 13.3581 8.99998C13.3581 9.16833 13.2909 9.33014 13.1708 9.4492L10.0262 12.5644C9.77591 12.8123 9.36953 12.8123 9.11926 12.5644C8.86901 12.3165 8.86905 11.9139 9.11926 11.666L11.1697 9.63474L5.28364 9.63474C4.92969 9.63474 4.64191 9.35062 4.64191 8.99998Z"
			fill="white"
		/>
	</svg>
);

const HiredIcon = () => (
	<svg {...iconProps}>
		<rect x="0.5" y="0.5" width="17" height="17" rx="8.5" fill="#27E3BD" />
		<rect x="0.5" y="0.5" width="17" height="17" rx="8.5" stroke="#27E3BD" />
		<path
			d="M12.7141 6.68587C12.8286 6.80036 12.8286 6.986 12.7141 7.10049L8.04968 11.7649C7.93518 11.8794 7.74955 11.8794 7.63505 11.7649L5.88588 10.0158C5.77138 9.90128 5.77138 9.71565 5.88588 9.60115C6.00037 9.48666 6.18601 9.48666 6.30051 9.60115L7.84236 11.143L12.2995 6.68587C12.414 6.57137 12.5996 6.57137 12.7141 6.68587Z"
			fill="white"
		/>
		<path
			d="M12.0557 6.33242C12.3784 6.02266 12.9019 6.02266 13.2245 6.33242C13.5472 6.64217 13.5472 7.14473 13.2245 7.45449L8.36618 12.1185C8.04352 12.4283 7.52003 12.4283 7.19736 12.1185L5.37548 10.3695C5.05282 10.0598 5.05282 9.55721 5.37548 9.24745C5.67795 8.95721 6.15675 8.9388 6.48122 9.19277L6.54429 9.24745L7.78126 10.435L12.0557 6.33242Z"
			fill="white"
		/>
	</svg>
);

const STAGE_ICONS = {
	rejected_by_client: RejectedIcon,
	rejected_by_recruiter: RejectedIcon,
	rejected_by_manager: RejectedIcon,
	on_hold_by_talent: OnHoldIcon,
	on_hold_by_candidate: OnHoldIcon,
	on_hold_by_client: OnHoldIcon,
	unresponsive: WithdrawnIcon,
	not_interested: WithdrawnIcon,
	internal_review: InternalReviewIcon,
	presented: PresentedIcon,
	client_assessment: ClientAssessmentIcon,
	client_definition: ClientDefinitionIcon,
	pre_hiring: PreHiringIcon,
	offer: OfferIcon,
	onboarding: OnboardingIcon,
	hired: HiredIcon
};

const JobApplicationStageIcon = ({ stage, className = '', ...rest }) => {
	const Icon = STAGE_ICONS[stage];

	if (!Icon) {
		return null;
	}

	return (
		<span
			className={`job-application-stage-icon ${className}`.trim()}
			{...rest}>
			<Icon />
		</span>
	);
};

export default JobApplicationStageIcon;
